import {
  GOLD_450,
  GOLD_600,
  MOON_200,
  MOON_300,
  MOON_400,
  MOON_600,
  MOON_800,
  TEAL_450,
  TEAL_600,
  THEME,
} from '@wandb/weave/common/css/color.styles';
import {type StylingValue} from 'react-json-tree';

// See https://github.com/reduxjs/redux-devtools/blob/main/packages/react-json-tree/src/createStylingFromTheme.ts#L11
const themeColors = {
  scheme: 'wandb',
  author: 'https://www.wandb.ai',
  base00: 'transparent', // background color
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e', // item_string_expanded
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: `light-dark(${MOON_800}, ${MOON_200})`, // text
  base08: '#f92672', // null, undefined, function, symbol
  base09: `light-dark(${TEAL_600}, ${TEAL_450})`, // string, date, item_string
  base0A: '#f4bf75',
  base0B: `light-dark(${GOLD_600}, ${GOLD_450})`, // number, boolean
  base0C: '#a1efe4',
  base0D: `light-dark(${MOON_600}, ${MOON_300})`, // label, arrow
  base0E: '#ae81ff',
  base0F: '#cc6633',
};

const arrowContainerPaddingRight = 12;
const valueMarginX = 12;

// This is how you style the various components of JSONTree.
// For the complete list, https://github.com/reduxjs/redux-devtools/blob/main/packages/react-json-tree/src/createStylingFromTheme.ts
// NOTE: Unfortunately, react-json-tree's root and rootChildren styling is broken. See SearchableJSONTree.less

const getTreeStyle: StylingValue = ({style}) => ({
  style: {
    ...style,
    marginLeft: 0,
    padding: '4px 0',
  },
});

// This is the <li> that wraps an arrow toggle group and its children
const getNestedNodeStyle: StylingValue = ({style}) => {
  return {
    style: {
      ...style,
      marginLeft: `${arrowContainerPaddingRight + 11}px`,
      paddingTop: 0,
      whiteSpace: 'nowrap',
    },
  };
};

const getNestedNodeLabelStyle: StylingValue = ({style}) => {
  return {
    style: {
      ...style,
      fontWeight: 650,
    },
  };
};

// This is the <ul> that wraps all of the children of an arrow toggle group (but not the arrow toggle group itself)
const getNestedNodeChildrenStyle: StylingValue = ({style}) => {
  return {
    style: {
      ...style,
      marginLeft: 0,
      paddingLeft: 0,
      margin: `${valueMarginX}px 0`,
    },
  };
};

// const getLabelStyle: StylingValue = ({style}, nodeType, expanded) => ({
//   style: {
//     ...style,
//     // fontWeight: 'bold',
//   },
// });

const getArrowContainerStyle: StylingValue = ({style}, nodeType, expanded) => ({
  style: {
    ...style,
    paddingRight: `${arrowContainerPaddingRight}px`,
    paddingLeft: 0,
    marginLeft: 0,
  },
});

// This applies to both the expand-group arrow, and the 'show more' double arrow.
const getArrowSignStyle: StylingValue = ({style}, nodeType, expanded) => ({
  style: {
    ...style,
    padding: 0,
    color: THEME.textTertiary,
  },
});

// This is a leaf (non-group) <li> element
const getValueStyle: StylingValue = ({style}, nodeType, expanded) => ({
  style: {
    ...style,
    paddingLeft: 0,
    paddingTop: 0,
    margin: `${valueMarginX}px ${arrowContainerPaddingRight + 11}px`,
    textIndent: 0,
  },
});

export const wbJSONTreeTheme = {
  extend: themeColors, // theme colors
  // label: getLabelStyle,
  // valueLabel: getValueLabelStyle,
  value: getValueStyle, // this is the <li> element
  tree: getTreeStyle,
  nestedNode: getNestedNodeStyle,
  nestedNodeLabel: getNestedNodeLabelStyle,
  nestedNodeChildren: getNestedNodeChildrenStyle,
  arrowSign: getArrowSignStyle,
  arrowContainer: getArrowContainerStyle,
};

// const monokaiJSONTreeTheme = {
//   scheme: 'monokai',
//   author: 'wimer hazenberg (http://www.monokai.nl)',
//   base00: '#272822',
//   base01: '#383830',
//   base02: '#49483e',
//   base03: '#75715e', // item_string_expanded
//   base04: '#a59f85',
//   base05: '#f8f8f2',
//   base06: '#f5f4f1',
//   base07: '#f9f8f5', // text
//   base08: '#f92672', // null, undefined, function, symbol
//   base09: '#fd971f', // number, boolean
//   base0A: '#f4bf75',
//   base0B: '#a6e22e', // string, date, item_string
//   base0C: '#a1efe4',
//   base0D: '#66d9ef', // label, arrow
//   base0E: '#ae81ff',
//   base0F: '#cc6633',
// };
